<template>
  <van-popup v-model="showBind" position="bottom" class="backRect" @closed="onClosed">
    <div class="inputRect">
      <div class="title">上传保单截图</div>
      <div class="imageUploadRect">
        <van-uploader
          v-model="fileList"
          class="imageUpload"
          :max-count="1"
          :after-read="afterRead"
        />
      </div>
      <div class="remark">请上传日期匹配有效的保单截图!</div>
      <div class="buttonRect">
        <van-button type="primary" size="large" :loading="buttonLoading" :color="GetColorMain()" @click="onUpload">上传</van-button>
      </div>
    </div>
  </van-popup>

</template>
<script>
import request from '@/utils/request'
import { Button, Popup, Uploader } from 'vant'
import { compressorImageList, MyNotify, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Uploader.name]: Uploader
  },
  props: {
    // eslint-disable-next-line
    value:undefined
  },
  data() {
    return {
      title: '上传保单截图',
      showBind: false,
      buttonLoading: false,
      studentId: undefined,
      fileList: []
    }
  },
  watch: {
    value(newValue) {
      this.fileList = []
      if (newValue) {
        this.showBind = true
        this.studentId = newValue
      } else {
        this.showBind = false
        this.studentId = undefined
      }
    }
  },
  created() {

  },
  methods: {
    compressorImageList,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    init() {
    },
    onClosed() {
      this.$emit('input', false)
    },
    afterRead() {

    },
    uploadImg(callback) {
      var noFile = true
      var fileList = []
      this.fileList.map((value, index, array) => {
        if (value.file) {
          fileList.push(value.file)
          noFile = false
        }
      })
      if (noFile) {
        if (callback) {
          callback()
        }
        return
      }
      compressorImageList(fileList, 1024, 1024, 0.6, (list) => {
        const formData = new FormData()
        list.map((value, index, array) => {
          if (value.name) {
            formData.append('file', value.file, value.name)
          } else {
            formData.append('file', value.file)
          }
        })
        request({
          url: '/Data/uploadFile?config=tripinsurance',
          method: 'post',
          data: formData
        }).then(response => {
          console.log('上传图片反馈', response)
          if (!response.success) {
            this.buttonLoading = false
            return
          }
          var list = []
          response.data.map((value, index, array) => {
            list.push(value.save)
          })
          if (callback) {
            callback(list.toString())
          }
        })
      })
    },
    onUpload() {
      this.buttonLoading = true
      this.uploadImg((data) => {
        request({
          url: '/divetrip/setDiveTripInsuranceImg',
          method: 'post',
          data: {
            studentId: this.studentId,
            image: data
          }
        }).then(response => {
          this.buttonLoading = false
          if (!response.success) {
            return
          }
          MyNotify('success', '上传保单截图成功')
          this.$emit('reload')
          this.showBind = false
        })
      })
    }
  }
}
</script>
<style scoped>
.backRect{
    width: 100vw;
    background-color: #fff;
}
.backRect .title{
    text-align: center;
    padding: 1em;
}
.backRect .imageUploadRect{
    padding: 1em;
}
.backRect .remark{
    font-size: 0.9em;
    color: #999;
    padding: 1em;
}
</style>
